export const GET_BARCODE_ITEMS = 'GET_BARCODE_ITEMS';
export const GET_BARCODE_ITEMS_SUCCESS = 'GET_BARCODE_ITEMS_SUCCESS';
export const GET_BARCODE_ITEMS_ERROR = 'GET_BARCODE_ITEMS_ERROR';
export const RESET_BARCODE_ITEMS = 'RESET_BARCODE_ITEMS';

export const SELECT_BARCODE_ITEM = 'SELECT_BARCODE_ITEM';
export const DESELECT_BARCODE_ITEM = 'DESELECT_BARCODE_ITEM';
// export const DESELECT_MANY_BARCODE_ITEMS = 'DESELECT_MANY_BARCODE_ITEMS';
export const RESET_BARCODE_ITEMS_ACTIONS = 'RESET_BARCODE_ITEMS_ACTIONS';

// export const OPEN_BARCODE_ITEM = 'OPEN_BARCODE_ITEM';
// export const CLOSE_BARCODE_ITEM = 'CLOSE_BARCODE_ITEM';

export const SET_BARCODE_ITEMS_FILTERS = 'SET_BARCODE_ITEMS_FILTERS';
export const SET_BARCODE_ITEMS_QUERY = 'SET_BARCODE_ITEMS_QUERY';

export const VALIDATE_BARCODE_ITEM = 'VALIDATE_BARCODE_ITEM';
export const VALIDATE_BARCODE_ITEM_SUCCESS = 'VALIDATE_BARCODE_ITEM_SUCCESS';
export const VALIDATE_BARCODE_ITEM_ERROR = 'VALIDATE_BARCODE_ITEM_ERROR';

export const SEARCH_BARCODE_ITEM = 'SEARCH_BARCODE_ITEM';
export const SEARCH_BARCODE_ITEM_SUCCESS = 'SEARCH_BARCODE_ITEM_SUCCESS';
export const SEARCH_BARCODE_ITEM_ERROR = 'SEARCH_BARCODE_ITEM_ERROR';
